import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import '../assets/css/main.css';
import {CopyToClipboard} from "react-copy-to-clipboard";
import axios from "axios";
import ReactGA from "react-ga";
import {isIE} from "react-device-detect";
import Ads from "./Ads";
import {API_URL, ADDY_URL} from '../config'

class Main extends Component {
    state = {
        rank_list: [],
        total_count: 0
    }

    componentDidMount() {
        ReactGA.pageview('/jungle');
        let height = document.body.clientHeight;
        document.documentElement.style.setProperty('--height', `${height}px`);
        axios.get(
            API_URL + '/api/v1/story/jungle/rank',
            {
                headers: {
                    'Authorization': "story_add_campus_312523"
                }
            }).then(({data: {data}}) => {
            this.setState({
                rank_list: data.rank_list,
                total_count: data.total_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            })
        }).catch((e) => {
            axios.get(ADDY_URL + '/api/v1/story/jungle/rank', {
                headers: {
                    'Authorization': "story_add_campus_312523"
                }
            }).then(({data: {data}}) => {
                this.setState({
                    rank_list: data.rank_list,
                    total_count: data.total_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                })
            })
        });
    }

    goStory() {
        this.props.history.push("/play");
    }

    copyAlert(url) {
        ReactGA.event({
            category: "Story-1 [쫄보테스트]",
            action: "Share",
            label: "Main"
        });
        if (navigator.share) {
            navigator.share({
                url: url
            }).then(() => {
                console.log('Thanks for sharing!');
            }).catch(console.error);
        } else {
            alert('복사 되었습니다.');
        }
    }

    render() {
        const {total_count, rank_list} = this.state;
        let ie_msg;
        if (isIE) {
            ie_msg = "해당 검사는 IE를 지원하지 않습니다. 다른 브라우저를 사용해주세요."
        }
        return (
            <div className="main">
                <Helmet>
                    <title>으스스한 정글! 쫄보유형 테스트</title>
                    <meta property="og:url" content="https://addcampus-story.s3.ap-northeast-2.amazonaws.com"
                          data-react-helmet="true"/>
                    <meta property="og:type" content="website" data-react-helmet="true"/>
                    <meta property="og:title" content="으스스한 정글! 쫄보유형 테스트" data-react-helmet="true"/>
                    <meta property="og:description" content="정글에 사는 수많은 쫄보동물들, 나는 어떤 쫄보 동물일까요?"
                          data-react-helmet="true"/>
                    <meta property="og:image"
                          content="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/main/Meta-Square.png"
                          data-react-helmet="true"/>
                </Helmet>
                {
                    ie_msg &&
                    <p style={{
                        textAlign: "center",
                        background: "#d9bed0",
                        fontWeight: "bold",
                        height: "30px",
                        fontSize: "20px",
                        margin: 0,
                        paddingTop: "10px"
                    }}>{ie_msg}</p>
                }
                <div className="main_background_img_compo">
                    <div className="main_background_img main_background_zoom"/>
                    <div className="main_foreground_img main_foreground_zoom"/>
                </div>
                <p className="easter_text">
                    Twowix
                </p>
                <div className="opacity_div">
                    <p className="sub_title">정글에 살고 있는 수 많은 쫄보 동물들!</p>
                    <p className="sub_2_title">나는 어떤 쫄보 유형일까요?</p>
                    <p className="story_title">으스스한 정글 탐험</p>
                    <p className="info_title">벌써 <span className="count_num">{total_count}</span> 명이 탐험을 완료했어요~!</p>
                    <button className="main_start_btn" onClick={() => this.goStory()}>지금 바로 시작하기</button>
                    <CopyToClipboard text="https://story.addcampus.com/jungle"
                                     onCopy={() => this.copyAlert("https://story.addcampus.com/jungle")}>
                        <div className="main_share_btn">
                            <img alt="icon" className="icon"
                                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/share-icon-white.svg"/>
                            <p className="text">URL 복사하기</p>
                        </div>
                    </CopyToClipboard>
                    <p className="warning_title"><img alt="sound_icon"
                                                      src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/sound-on-yellow.svg"/>사운드가
                        포함되어 있으니, 수업중이나 직장에선 조심조심…</p>
                    <Ads style={{marginTop: "20px"}}/>
                </div>
                <div className="rank_list">
                    <p className="rank_text">가장 많은 쫄보동물</p>
                    {
                        rank_list ?
                            rank_list.map((item, index) => {
                                let img_src = "https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/main/Main-0" + item.result_id + ".png"
                                return (
                                    <div key={index} className="main_rank_compo">
                                        <img src={img_src} alt="profile_img"/>
                                        <p>{index + 1} 위</p>
                                    </div>
                                )
                            }) : null
                    }
                    <p className="copyright">2020 Copyright @ TENDOM. All rights reserved.</p>
                    <a href="mailto:info@tendom.co.kr" className="copyright">Contact Us</a>
                </div>
            </div>
        )
    }
}

export default Main;
